import { ITimeTrackerApi, TimeTrackerApi } from '../data/timetracker-api-client';

export abstract class DataService {
    protected static client: ITimeTrackerApi = new TimeTrackerApi(process.env.REACT_APP_API);
}
